import { useSesion } from '../lib/sesion.ts';

/** Pie de página discreto, estilo lumin: la marca de la empresa + Post Maker. */
export function PieDePagina() {
  const { data: sesion } = useSesion();
  const nombre = sesion?.branding?.nombreVisible ?? sesion?.empresa?.nombre ?? 'Post Maker';

  return (
    <footer className="px-4 pb-6 pt-2 md:px-8">
      <div className="tarjeta flex flex-wrap items-center justify-between gap-2 px-5 py-3 text-xs text-suave">
        <p className="flex items-center gap-2">
          <span
            className="h-2.5 w-2.5 rounded-full"
            style={{ backgroundColor: 'var(--color-acento-var)' }}
          />
          © {new Date().getFullYear()} {nombre}
        </p>
        <p>
          Hecho con <span className="font-medium text-principal">Post Maker</span>
        </p>
      </div>
    </footer>
  );
}
